const { getCurrentDateWithFirstDay } = require('./utils/getCurrentDateWithFirstDay')
const { getTimezoneOffsetDiffInMs } = require('./utils/getTimezoneOffsetDiffInMs')
const { getHoursBetweenDateTimes } = require('./utils/getHoursBetweenDateTimes')
const { getDatePartsBetweenDates } = require('./utils/getDatePartsBetweenDates')
const { getDaysCountBetweenDates } = require('./utils/getDaysCountBetweenDates')
const { getDateFromExcelNumber } = require('./utils/getDateFromExcelNumber')
const { getMonthsBetweenDates } = require('./utils/getMonthsBetweenDates')
const { getCurrentDateAndTime } = require('./utils/getCurrentDateAndTime')
const { getYearsBetweenDates } = require('./utils/getYearsBetweenDates')
const { getWeeksBetweenDates } = require('./utils/getWeeksBetweenDates')
const { getDaysBetweenDates } = require('./utils/getDaysBetweenDates')
const { addSubDaysFullDate } = require('./utils/addSubDaysFullDate')
const { getCurrentSeconds } = require('./utils/getCurrentSeconds')
const { getDateInstance } = require('./utils/getDateInstance')
const { getCurrentYear } = require('./utils/getCurrentYear')
const { getCurrentTime } = require('./utils/getCurrentTime')
const { getCurrentDate } = require('./utils/getCurrentDate')
const { addSubDaysDate } = require('./utils/addSubDaysDate')
const { isDateBetween } = require('./utils/isDateBetween')
const { getMonthName } = require('./utils/getMonthName')
const { getFullDate } = require('./utils/getFullDate')
const { isValidDate } = require('./utils/isValidDate')
const { getSeconds } = require('./utils/getSeconds')
const { addSubDays } = require('./utils/addSubDays')
const { getDiffMs } = require('./utils/getDiffMs')
const { getDate } = require('./utils/getDate')
const { getYear } = require('./utils/getYear')
const { getTime } = require('./utils/getTime')
const { isToday } = require('./utils/isToday')
const { consts } = require('./consts')

const DateTime = {
  now: Date.now,
  getMonthName,
  getMonthsBetweenDates,
  getHoursBetweenDateTimes,
  isToday,
  getCurrentDateAndTime,
  getCurrentYear,
  getTimezoneOffsetDiffInMs,
  getCurrentDate,
  isDateBetween,
  getCurrentTime,
  getDateFromExcelNumber,
  getDateInstance,
  getDate,
  getFullDate,
  addSubDays,
  getCurrentSeconds,
  isValidDate,
  getTime,
  getYear,
  getDaysCountBetweenDates,
  getCurrentDateWithFirstDay,
  getDaysBetweenDates,
  addSubDaysDate,
  addSubDaysFullDate,
  getYearsBetweenDates,
  getDatePartsBetweenDates,
  getDiffMs,
  getWeeksBetweenDates,
  getSeconds,
  SECOND_IN_MS: consts.SECOND_IN_MS,
  MINUTE_IN_MS: consts.MINUTE_IN_MS,
  HOUR_IN_MS: consts.HOUR_IN_MS,
  DAY_IN_MS: consts.DAY_IN_MS,
  WEEK_IN_MS: consts.WEEK_IN_MS,
  MONTH_IN_MS: consts.MONTH_IN_MS,
  DAYS_OF_WEEK: consts.DAYS_OF_WEEK,
  DAYS_OF_YEAR: consts.DAYS_OF_YEAR,
  SECONDS_IN_HOUR: consts.SECONDS_IN_HOUR
}

module.exports.DateTime = DateTime
